import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Breadcrumb } from "@themesberg/react-bootstrap";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTable from "../../components/DataTable";
import {
  getProductosAction,
  comenzarEditarProductoAction,
  showModalAgregarProductoAction,
  eliminarProductoAction,
} from "../../actions/productosActions";
import { getUnidadesMedicionAction } from "../../actions/unidadesMedicionActions";

import { getCategoriasProductosAction } from "../../actions/categoriasProductosActions";

import { ConfirmModal } from "../../components/ConfirmModal";
import EditarProducto from "./EditarProducto";
import AgregarProducto from "./AgregarProducto";

import EmptyImg from "../../assets/img/emptyimg.png";
import ModalProductoProveedores from "./ModalProductoProveedores";
import { columnaSucursalDT } from "../../helpers";

import {
  getDatosAdicionalesAction,
  getTabsDatosAdicionalesAction,
  setModalDatosAdicionalesAction,
} from "../../actions/datosAdicionalesActions";
import DatosAdicionales from "../../components/DatosAdicionales/DatosAdicionales";
import { getDatosAdicionalesDetallesAction } from "../../actions/datosAdicionalesDetallesActions";

export default () => {
  const dispatch = useDispatch();

  const { loadingProductos, producto, productos } = useSelector(
    (state) => state.productos
  );
  const [showModalProveedores, setShowModalProveedores] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);

  useEffect(() => {
    dispatch(getProductosAction());
    dispatch(getUnidadesMedicionAction());
    dispatch(getCategoriasProductosAction());
  }, []);

  const columns = [
    {
      text: "Imagen",
      align: "center",
      sortable: false,
      width: "8%",
      cell: (record) => {
        return (
          <img
            src={
              record.imagen
                ? process.env.REACT_APP_API_BASE_URL + "/image/" + record.imagen
                : EmptyImg
            }
            alt={record.nombre}
            width={50}
            height={50}
            style={{ objectFit: "contain" }}
          />
        );
      },
    },
    {
      key: "id",
      text: "ID",
      className: "id",
      align: "left",
      sortable: true,
    },
    {
      key: "nombre",
      text: "Nombre",
      className: "nombre",
      align: "left",
      sortable: true,
    },
    {
      key: "descripcion",
      text: "Descripción",
      className: "descripcion",
      align: "left",
      sortable: true,
    },
    {
      key: "codigo",
      text: "Codigo",
      className: "codigo",
      align: "left",
      sortable: true,
    },
    {
      key: "precio",
      text: "Precio venta",
      className: "precio",
      align: "left",
      sortable: true,
    }
  ];

  const state = {
    records: productos,
  };

  const extraButtons = [
    {
      className: "btn btn-info",
      title: "Agregar producto",
      children: [
        <span>
          <i class="fas fa-plus"></i> Nuevo
        </span>,
      ],
      onClick: (event) => {
        dispatch(showModalAgregarProductoAction(true));
        dispatch(getTabsDatosAdicionalesAction("PRODUCTOS"));
        dispatch(getDatosAdicionalesAction("PRODUCTOS"));
      },
    },
    {
      className: "btn btn-primary",
      title: "Datos adicionales",
      children: [
        <span>
          <i class="fas fa-plus"></i> Datos adicionales
        </span>,
      ],
      onClick: (event) => {
        dispatch(setModalDatosAdicionalesAction(true));
        dispatch(getDatosAdicionalesAction("PRODUCTOS"));
      },
    },
  ];

  const editRecord = (record) => {
    dispatch(comenzarEditarProductoAction(record));
    dispatch(getTabsDatosAdicionalesAction("PRODUCTOS"));
    dispatch(getDatosAdicionalesAction("PRODUCTOS", record.id));
    dispatch(getDatosAdicionalesDetallesAction("PRODUCTOS", record.id));
  };

  const deleteRecord = (record) => {
    const callbacks = [
      {
        event: dispatch,
        action: eliminarProductoAction,
        args: [record],
      },
    ];

    ConfirmModal(callbacks);
  };

  const verProveedores = (record) => {
    setShowModalProveedores(true);
    setProductoSeleccionado(record);
  };

  const acciones = [
    {
      description: "Proveedores",
      icon: "fas fa-book-medical",
      className: "btn btn-success btn-sm",
      event: verProveedores,
      style: { marginRight: "5px" },
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Productos</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body>
          <h5 className="mb-4">Productos</h5>
          <DataTable
            columns={columns}
            editRecord={editRecord}
            deleteRecord={deleteRecord}
            acciones={acciones}
            state={state}
            extraButtons={extraButtons}
            loading={loadingProductos}
          />
        </Card.Body>
      </Card>

      <EditarProducto />
      <AgregarProducto />
      <ModalProductoProveedores
        showModal={showModalProveedores}
        onHide={() => {
          setShowModalProveedores(false);
          setProductoSeleccionado(null);
        }}
        producto={productoSeleccionado}
      />
      <DatosAdicionales tabla="PRODUCTOS" />
    </>
  );
};
